import React from 'react'

function CardProdut({imgSrc, imgAlt, price, nameProduct}) {
  return (
    <div className='card-product flex-center flex-column fade-up'>
        <div className='img img-200'>
            <img src={imgSrc} alt={imgAlt} width="200" height="200"/>
        </div>
        <div className='flex-center flex-column'>
            <h2>R$ {price}</h2>
            <h3>{nameProduct}</h3>
        </div>
    </div>
  )
}

export default CardProdut
